import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { find, isEmpty } from "lodash";

import { Typography } from "../Typography";
import { StarsRating } from "../StarsRating";
import { FeedbackHeader } from "./FeedbackHeader";
import { FeedbackNavigation } from "./FeedbackNavigation";

import { FEEDBACK_PREVIEW_INDEX } from "@/utils/feedbackPreviewNavigation";

import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";

import { SingleFeedbackProps } from "./types";

const MAX_CHARACTERS = 1000;

export const SingleFeedback = ({
  data,
  isInitPreview,
  hasMultipleCategories,
  category,
}: SingleFeedbackProps) => {
  const { themeColor } = data;
  const { t } = useTranslation("feedback");

  const [count, setCount] = useState(0);
  const [reviewComment, setReviewComment] = useState(undefined);

  const qrFeedbackContextData = useContext<QRFeedbackContextProps>(QRFeedbackContext);

  const {
    selectedReviewCategory,
    ratingSelected,
    currentView,
    feedbackReviewData,
    setSelectedReviewCategory,
  } = qrFeedbackContextData;

  useEffect(() => {
    if (!isNaN(ratingSelected) && !isEmpty(feedbackReviewData.categories)) {
      setSelectedReviewCategory({
        ...selectedReviewCategory,
        rating: ratingSelected,
      });
    }
  }, [ratingSelected]);

  useEffect(() => {
    if (!isEmpty(feedbackReviewData.categories)) {
      if (reviewComment !== undefined) {
        setSelectedReviewCategory({
          ...selectedReviewCategory,
          comment: reviewComment,
        });
      }
    }
  }, [reviewComment]);

  const handleReviewCommentData = (e) => {
    setCount(e.target.value.length);
    setReviewComment(e.target.value);
  };

  const defaultRatingValue = (category) => {
    if (isInitPreview !== undefined) return 3;
    if (category.rating !== undefined && category.rating !== null) return category.rating;
  };

  return (
    <>
      {currentView !== FEEDBACK_PREVIEW_INDEX.HOME_SINGLE_CATEGORY && !isInitPreview && (
        <FeedbackNavigation hasMultipleCategories={hasMultipleCategories} />
      )}

      <div className={`feedback-single ${hasMultipleCategories ? "hasMultipleCategories" : ""}`}>
        {(currentView === FEEDBACK_PREVIEW_INDEX.HOME_SINGLE_CATEGORY || isInitPreview) && (
          <FeedbackHeader data={data} />
        )}
        <div className="feedback-categories">
          {(category || isInitPreview) && (
            <div className="feedback-category">
              <div className="feedback-form">
                {category?.name && (
                  <Typography
                    Tag="p"
                    size="m"
                    classname="feedback-category--name"
                    style={{ color: themeColor?.buttonColor }}
                  >
                    {find(data.categories, { id: category?.id })?.name}
                  </Typography>
                )}
                {(isInitPreview || category?.rating !== undefined) && (
                  <div className="feedback-category--rating">
                    <StarsRating defaultCheckedValue={defaultRatingValue(category)} />
                  </div>
                )}

                <div className="feedback-category--input">
                  <label
                    htmlFor={`feedback-input`}
                    className="feedback-label"
                  >
                    {t("textarea_label")}
                  </label>
                  <textarea
                    id={`feedback-input`}
                    className="feedback-textarea"
                    name="feedback"
                    maxLength={MAX_CHARACTERS}
                    onChange={(e) => handleReviewCommentData(e)}
                    placeholder={t("textarea_placeholder")}
                    defaultValue={category?.comment}
                  />
                  {/* TODO:: Extend Input component to add maxLength functionality */}
                  <div className="feedback-textarea--counter">
                    {count}/{MAX_CHARACTERS}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
